import Box from 'assets/components/box/Box';
import Button from 'assets/components/button/Button';
import ThemeButtonCircle from 'assets/components/button/themes/Theme.Button.Circle';
import DataMap from 'assets/components/dataMap/DataMap';
import Icon from 'assets/components/icon/Icon';
import Page from 'assets/components/page/Page';
import ThemePageError from 'assets/components/page/themes/Theme.Page.Error';
import ThemeTableSimple from 'assets/components/table/themes/Theme.Table.Simple';
import { getLocales } from 'assets/locales/Locale';
import ThemeWrapperStack from 'assets/themes/wrappers/Theme.Wrapper.Stack';
import { combineStrings } from 'assets/utils/data/String';
import { VehicleModelAction, useVehicleModelProvider } from '../VehicleModel.Hooks';

export default function VehicleModelList() {
  const { lang } = getLocales();
  const { listApi, pageRouter, permissions } = useVehicleModelProvider();

  return !listApi.payload && !listApi.isExecuting && listApi.apiCounter > 0 ? (
    <Page
      class={ThemePageError}
      sidebar={<Icon class="fas-clipboard-list" />}
      header={lang.vehicleModels}
      render={lang.noInfo}
    />
  ) : (
    <table className={ThemeTableSimple}>
      <thead>
        <tr>
          <th>{lang.name}</th>
          <th>{lang.makeCode}</th>
          <th>{lang.classes}</th>
          <th data-actions>{lang.actions}</th>
        </tr>
      </thead>
      <tbody>
        <DataMap
          data={listApi.payload?.data}
          render={({ data: vehicleModel }) => (
            <tr key={vehicleModel?.id}>
              <td>
                <b>{vehicleModel.name}</b>
              </td>
              <td>{vehicleModel.vehicleMake?.makeCode}</td>
              <td>
                {vehicleModel.vehicleClasses
                  ?.map((it) => combineStrings(' - ', it.primaryCode, it.secondaryCode))
                  ?.join(', ')}
              </td>
              <td>
                <Box class={ThemeWrapperStack}>
                  <Button
                    onClick={pageRouter.updateParams}
                    data={{
                      id: vehicleModel?.id.toString(),
                      action: VehicleModelAction.EDIT,
                    }}
                    disabled={!permissions.EDIT_VEHICLEMODEL}
                    class={ThemeButtonCircle}
                    media={<Icon class="fas-edit" />}
                    htmlElementProps={{ title: lang.edit }}
                    active
                  />
                  <Button
                    onClick={pageRouter.updateParams}
                    data={{
                      id: vehicleModel?.id.toString(),
                      action: VehicleModelAction.DELETE,
                    }}
                    disabled={!permissions.DELETE_VEHICLEMODEL}
                    class={ThemeButtonCircle}
                    media={<Icon class="fas-trash" />}
                    htmlElementProps={{ title: lang.delete }}
                    active
                  />
                </Box>
              </td>
            </tr>
          )}
        />
      </tbody>
    </table>
  );
}
